import { massUpdateActions } from 'constants/MassUpdates';
import React, { useState } from 'react';
import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, } from '@cargomatic/ui';
import { ChevronDown } from 'lucide-react';
import BulkEditModal from 'components/modules/orders/MassUpdateModal';
import useModal from 'hooks/useModal';
import { useTranslation } from 'react-i18next';
import SessionStore from 'stores/SessionStore';
import { OverrideBillingStatusModal } from 'components/modules/shipments/OverrideBillingStatusModal';
const { UPDATE_ACCOUNTING_REVIEW_DATE, OVERRIDE_BILLING_STATUS } = massUpdateActions;
function BulkActionsDropdown({ view, disabled, selectedOrders }) {
    const { t } = useTranslation();
    const [bulkAction, setBulkAction] = useState('');
    const overrideBillingStatusEnabled = SessionStore.isBillingStatusAdmin();
    const { visible: bulkEditModalVisible, show: showBulkEditModal, close: closeBulkEditModal, } = useModal();
    const { visible: overrideBillingStatusModalVisible, show: showOverrideBillingStatusModal, close: closeOverrideBillingStatusModal, } = useModal();
    const handleBulkAction = (bulkAction) => {
        switch (bulkAction) {
            case OVERRIDE_BILLING_STATUS:
                showOverrideBillingStatusModal();
                break;
            case UPDATE_ACCOUNTING_REVIEW_DATE:
            default:
                setBulkAction(bulkAction);
                showBulkEditModal();
                break;
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(DropdownMenu, null,
            React.createElement(DropdownMenuTrigger, { asChild: true },
                React.createElement(Button, { variant: "outline", disabled: disabled, className: `mr-2 ${disabled ? 'disabled' : ''}` },
                    t('ACTIONS'),
                    " ",
                    React.createElement(ChevronDown, { className: "ml-2 h-4 w-4" }))),
            React.createElement(DropdownMenuContent, null,
                React.createElement(DropdownMenuItem, { onClick: () => handleBulkAction(UPDATE_ACCOUNTING_REVIEW_DATE) }, `${t('UPDATE')} ${t('ACCOUNTING_REVIEW_DATE')}`),
                overrideBillingStatusEnabled && (React.createElement(DropdownMenuItem, { disabled: view !== 'drayage', onClick: () => {
                        if (view !== 'drayage')
                            return;
                        handleBulkAction(OVERRIDE_BILLING_STATUS);
                    } }, t('OVERRIDE_BILLING_STATUS'))))),
        bulkEditModalVisible && (React.createElement(BulkEditModal, { show: true, action: bulkAction, onHide: closeBulkEditModal, orders: selectedOrders })),
        overrideBillingStatusEnabled && overrideBillingStatusModalVisible && (React.createElement(OverrideBillingStatusModal, { orderIds: selectedOrders.map((order) => order.order_oid), open: overrideBillingStatusModalVisible, onHide: closeOverrideBillingStatusModal }))));
}
export default BulkActionsDropdown;
